var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-group"},[_c('el-checkbox-group',{model:{value:(_vm.checkList),callback:function ($$v) {_vm.checkList=$$v},expression:"checkList"}},_vm._l((_vm.options),function(item,idx){return _c('div',[_c('el-checkbox',{key:idx,attrs:{"label":item.name,"value":item.value}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }